var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_c('div',{staticClass:"message__icon"},[_vm._t("icon")],2),_c('div',{staticClass:"message__text"},[_vm._t("text")],2),_c('div',{staticClass:"message__text-additional"},[_vm._t("additional-text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }